import classnames from "classnames";
import { ModalDeleteIcon } from "components/assets/Icons";
import Button, { SIZE as VIEW, COLOR } from "components/Button";
import trucksService from "services/trucks.service";

import styles from "./DeleteModal.module.scss";

const ModalDelete = ({ data, setShowModal, setSuccess }) => {
  const handleOnClick = (e) => {
    e.preventDefault();
    trucksService
      .deleteTruck(data.item)
      .then((res) => {
        setTimeout(() => {
          setShowModal(false);
          setSuccess("Truck has been deleted!");
        }, 500);
      })
      .catch((e) => {
        console.error("Delete truck error:", e.response?.data);
      });
  };

  return (
    <div className={classnames(styles.content, styles.delete_content)}>
      <ModalDeleteIcon />
      <h2 className={styles.title}>Delete Truck</h2>
      <p className={styles.description}>
        Do you want to delete this truck? This process cannot be undone
      </p>
      <div className={styles.group}>
        <Button size={VIEW.MIDDLE} color={COLOR.NONE} onClick={() => setShowModal(false)}>
          Back
        </Button>
        <Button size={VIEW.MIDDLE} onClick={handleOnClick}>
          Delete
        </Button>
      </div>
    </div>
  );
};

export default ModalDelete;
